import React from 'react';
import styles from './index.css';
import { wapactPageCount } from '../../../utils/h5PageCount';
import { storage } from '../../../base/base';
import { formatImageWebpAuto } from '../../../base/publicMethod/index';
const { LazyImg } = require('@ifeng-fe/ui_pc_lazyLoad');
const { callApp } = require('@ifeng-fe/callapp');
class MdBanner extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleCallup = () => {
            const { content } = this.props;
            const { secretCallUp, type, id, url, kind, wapactCount, noPrefixKind, isVideoShare } = content;
            const doc_type = type;
            const aid = id;
            const client = isVideoShare ? 'videoApp' : 'newsApp';
            if (secretCallUp && !storage.getSession('secretCallSign')) {
                this.feedClickCountFn(wapactCount);
                callApp({
                    client,
                    docType: doc_type,
                    pid: aid,
                    hasComment: 1,
                    kind,
                    isSecretCall: secretCallUp,
                    secretGoUrl: url,
                    noKindFrom: noPrefixKind
                });
            }
        };
        this.feedClickCountFn = (config = {}) => {
            if (Object.keys(config).length > 0) {
                wapactPageCount(config);
            }
        };
    }
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const loadImgUrl = 'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="375" height="188"><text x="120" y="108" fill="%23dcdcdc" style="font-size: 28px;">%E9%B3%B3%E5%87%B0%E6%96%B0%E8%81%9E</text></svg>';
        return (React.createElement("section", { className: styles.mdBanner },
            React.createElement("a", { href: content.link, onClick: this.handleCallup.bind(this), className: styles.mdBannerBox },
                React.createElement(LazyImg, { placeholder: loadImgUrl, src: formatImageWebpAuto(content.image, 750, 376), className: styles.mdBannerPic, loadData: "load success!!" }),
                React.createElement("div", { className: styles.mdBannerTitBox },
                    React.createElement("h2", { className: styles.mdBannerTit }, content.title)))));
    }
}
export default MdBanner;
